import ErrorBoundary from "../../ErrorBoundary";
import React from 'react';
import BaseSubGridPanel from "../../Base/BaseSubGridPanel";

const keyName = `SpecStatusSub`;

export default class SpecStatusSub extends BaseSubGridPanel {

    constructor(props) {
        super(props);
        if (window.IasConfig.devMode) console.debug(`${keyName} constructor`, props);
        const context = this;
        context.topMenuButtonNames=['add','reload'];
        context.subElementName = 'BaseEditPage';
        context.gridName=`SpecStatusSubGrid`;
        context.idName ='row_id';
        context.noSingle=true;
    }

    //заголовок окна
    setDialogTitle(context) {
//        context.dialog.cmp.setTitle(`Краснокнижное описание вида ${context.grid.getCurrentRow()[`name_rus`]}`);
    }

}

